import React from 'react';
import { useNavigate } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';

const Home = () => {
    const navigate = useNavigate();
    usePageTitle("Dinara Fariz");

    return (
        <div className="w-full flex justify-center px-4">
            <div
                className="w-full max-w-[700px] h-[60vh] min-h-[420px] sm:h-[650px] md:h-[900px] bg-cover bg-center flex flex-col items-center justify-center text-center"
                style={{
                    backgroundImage: "url('/DinaraMain.jpg')",
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center top',
                }}
            >
                <h1 className="text-white text-sm sm:text-base md:text-lg font-light mb-6 drop-shadow-md uppercase tracking-[0.2em]">
                    To purchase paintings please click here
                </h1>
                <button
                    onClick={() => navigate('/gallery')}
                    className="text-white border border-white px-6 py-2 uppercase tracking-widest hover:bg-white/20 hover:text-white transition"
                >
                    Click here
                </button>
            </div>
        </div>
    );
};

export default Home;
